exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mb-5[data-v-b6455fe0]{margin-bottom:1.25rem}.mt-7[data-v-b6455fe0]{margin-bottom:1.75rem}.mr-3[data-v-b6455fe0]{margin-right:.75rem}.mr-2[data-v-b6455fe0]{margin-right:.5rem}.modal__content[data-v-b6455fe0]{text-align:center;padding:20px;background-color:hsla(0,0%,100%,.9)}.modal__content .acknowledgement-content[data-v-b6455fe0]{color:#000;max-height:65vh;overflow-y:auto;padding:20px;margin-bottom:10px}h4.modal__ttl--primary[data-v-b6455fe0]{font-size:24px}.modal__close[data-v-b6455fe0]{margin-top:40px}option[data-v-b6455fe0]{color:#000;background:#fff}.acknowledgement-agree[data-v-b6455fe0]{color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b6455fe0","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/SeatPickerAcknowledgementModal.vue
// module id = NLyj
// module chunks = 115 116